import styled from '@emotion/styled';
import { Button } from '@presentation/components';
import { Link } from 'react-router-dom';

export const LoginWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 12px;
`;

export const LoginLink = styled(Link)`
  color: ${(props) => props.theme.color.blue.default};
  font-weight: 700;
  margin-left: 12px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.color.light.shade};
  margin: 20px 0;
`;

export const LinkSpan = styled.span`
  display: inline;
  p {
    margin-bottom: 0;
    margin-top: 0;
    display: inline;
  }

  a {
    color: inherit;
    font-weight: inherit;
    &:hover {
      color: ${(props) => props.theme.color.blue.default};
      text-decoration: underline;
    }
  }
`;

export const SsoButtonIconWrapper = styled.div`
  margin-right: 12px;
  width: 20px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SsoButtonFacebook = styled(Button)`
  background: #3b5998;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;
